import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const FilterIcon: FC<IconProps> = ({ size = 20, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path fillRule='evenodd' clipRule='evenodd'
          d='M2.5 2.875C2.15837 2.875 1.84798 3.07383 1.70514 3.38417C1.56231 3.69451 1.61316 4.05959 1.83535 4.31909L7.625 11.0808V16.0185C7.625 16.3515 7.814 16.6556 8.11256 16.803L11.1126 18.2845C11.3838 18.4185 11.7049 18.4028 11.9619 18.2432C12.2188 18.0835 12.375 17.8025 12.375 17.5V11.0808L18.1646 4.31909C18.3868 4.05959 18.4377 3.69451 18.2949 3.38417C18.152 3.07383 17.8416 2.875 17.5 2.875H2.5ZM9.16464 10.1883L4.40113 4.625H15.5989L10.8354 10.1883C10.6996 10.3469 10.625 10.5487 10.625 10.7574V16.092L9.375 15.4747V10.7574C9.375 10.5487 9.30039 10.3469 9.16464 10.1883Z'
          fill={color} />
  </svg>
)

export default FilterIcon
